import { Reducer } from "redux";
import { GameAction, GameActionTypes } from "../actions/Game";

export interface State {
  vGamepads: Record<string, unknown>;
}
const initialState: State = {
  vGamepads: {},
};

export const reducer: Reducer<State> = (state = initialState, action: GameAction) => {
  switch (action.type) {
    case GameActionTypes.SET_VG_DESCRIPTION: {
      const vGamepads = { ...state.vGamepads };
      vGamepads[action.url] = action.description;
      return { ...state, vGamepads };
    }
    default:
      return state;
  }
};
